import { FEATURE_FLAGS, REDIS_FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';

const primaryMenuItems = (accountId, locale = 'pt_BR') => {
  // Map locale to URL code
  const localeMap = {
    en: 'en',
    es: 'es',
  };

  const faqLocale = localeMap[locale] || 'pt_BR';
  const faqUrl = `https://cloudchat.cloudhumans.com/hc/cloud-chat/${faqLocale}`;

  return [
    {
      icon: 'mail-inbox',
      key: 'inboxView',
      label: 'INBOX_VIEW',
      featureFlag: FEATURE_FLAGS.INBOX_VIEW,
      toState: frontendURL(`accounts/${accountId}/inbox-view`),
      toStateName: 'inbox_view',
    },
    {
      icon: 'chat-alt-6',
      key: 'conversations',
      label: 'CONVERSATIONS',
      toState: frontendURL(`accounts/${accountId}/dashboard`),
      toStateName: 'home',
    },
    {
      icon: 'captain',
      key: 'captain',
      label: 'CAPTAIN',
      featureFlag: FEATURE_FLAGS.CAPTAIN,
      toState: frontendURL(`accounts/${accountId}/captain`),
      toStateName: 'captain',
    },
    {
      icon: 'claudia',
      key: 'claudia',
      label: 'CLAUDIA',
      redisFeatureFlag: REDIS_FEATURE_FLAGS.CLAUDIA,
      toState: frontendURL(`accounts/${accountId}/claudia`),
      toStateName: 'claudia_app',
    },
    {
      icon: 'users-2',
      key: 'contacts',
      label: 'CONTACTS',
      featureFlag: FEATURE_FLAGS.CRM,
      toState: frontendURL(`accounts/${accountId}/contacts`),
      toStateName: 'contacts_dashboard',
    },
    {
      icon: 'graph-increase',
      key: 'reports',
      label: 'REPORTS',
      featureFlag: FEATURE_FLAGS.REPORTS,
      toState: frontendURL(`accounts/${accountId}/reports`),
      toStateName: 'account_overview_reports',
    },
    {
      icon: 'arrow-trending-lines',
      key: 'new-reports',
      label: 'REPORTS',
      toState: frontendURL(`accounts/${accountId}/new-reports`),
      toStateName: 'new_conversation_reports',
      superAdminOnly: true,
    },
    {
      icon: 'megaphone-2',
      key: 'campaigns',
      label: 'CAMPAIGNS',
      featureFlag: FEATURE_FLAGS.CAMPAIGNS,
      toState: frontendURL(`accounts/${accountId}/campaigns`),
      toStateName: 'one_off',
    },
    {
      icon: 'library',
      key: 'helpcenter',
      label: 'HELP_CENTER.TITLE',
      featureFlag: FEATURE_FLAGS.HELP_CENTER,
      alwaysVisibleOnChatwootInstances: true,
      toState: frontendURL(`accounts/${accountId}/portals`),
      toStateName: 'default_portal_articles',
    },
    {
      icon: 'cog',
      key: 'settings',
      label: 'SETTINGS',
      toState: frontendURL(`accounts/${accountId}/settings`),
      toStateName: 'settings_home',
    },
    {
      icon: 'question-circle',
      key: 'faq',
      label: 'FAQ',
      openInNewPage: true,
      toState: faqUrl,
      toStateName: 'faq',
    },
    {
      icon: 'invention',
      key: 'product-feedback',
      label: 'PRODUCT_FEEDBACK',
      openInNewPage: true,
      toState: 'https://cloudhumans.canny.io/feature-request-cloud-chat',
      toStateName: 'product_feedback',
    },
  ];
};

export default primaryMenuItems;
